/**
 * Inicialización de Firebase (v8 compat).
 * Antes este código estaba inline en snippets/firebase.liquid y los SDK bloqueaban el render de todas las páginas.
 * Ahora los tres scripts se cargan con "defer" (se ejecutan en orden, antes de DOMContentLoaded),
 * conservando exactamente los mismos globales: firebaseConfig y db (y userId, definido en el snippet).
 */
const firebaseConfig = {
  apiKey: "AIzaSyBnYY_obq6ZaHAq_keWAvfhxKnKzGsG__k",
  authDomain: "akibara-album.firebaseapp.com",
  projectId: "akibara-album",
  storageBucket: "akibara-album.appspot.com",
  messagingSenderId: "1025064017148",
  appId: "1:1025064017148:web:320b3268cffd8395ad4b79"
};

// Inicializa Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
console.log("Firebase inicializado con éxito.");
